export const sentenceCasing = `
  text-transform: lowercase;
  &:first-letter {
    text-transform: uppercase;
    }
  `;
export const standardContainerWidth = `
  min(100%, calc(600px + (2 * var(--standard-spacing-x, 24px))))
  `;
/**
 * This is used to set the standard width of a component.
 * Which is 100% of the parent container, or 600px + 2 * var(--standard-spacing-x)
 */
export const standardContainerStyling = (spacingType = 'margin') => `
  width: ${standardContainerWidth};
  ${spacingType}-right: var(--standard-spacing-x, 24px);
  ${spacingType}-left: var(--standard-spacing-x, 24px);
  `;
//# sourceMappingURL=mixins.js.map